import React from "react";
// import { useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import logo from "../images/logo.png";

import {
  appBarStyles,
  logoStyles,
  logoMobileStyles,
  titleStyles,
  // titleMobileStyles,
  buttonStyles,
  underlineStyles,
} from "../css/navbarStyle.js";

const pages = [
  { name: "Home", id: "Home" },
  { name: "Videos", id: "Videos" },
  { name: "Pages", id: "Pages" },
  { name: "Pricing", id: "Pricing" },
  { name: "Policy pages", id: "PolicyPages" },
  { name: "FAQs", id: "FQA" },
];

const subpages = [
  { name: "Mobile Pages", id: "Pages" },
  { name: "Features", id: "Features" },
  { name: "Compare Package", id: "Compare_package" },
];

const policyPages = [
  { name: "Payment Policy", id: "Payment_Policy" },
  { name: "Terms of service", id: "Terms_of_service" },
  { name: "Disclaimer", id: "Disclaimer" },
  { name: "Privacy policy", id: "privacy_policy" },
  { name: "Cancellation refund policy", id: "cancellation_refund_policy" },
  { name: "Intellectual property claim", id: "intellectual_property_claim" },
];

function Navbar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElPages, setAnchorElPages] = React.useState(null);
  const [selectedPage, setSelectedPage] = React.useState("Home");
  const [isPagesOpen, setIsPagesOpen] = React.useState(false); // Tracks "Pages" menu state
  // const navigate = useNavigate();

  const handleOpenNavMenu = (event) => setAnchorElNav(event.currentTarget);
  const handleCloseNavMenu = () => setAnchorElNav(null);

  const [anchorElPolicyPages, setAnchorElPolicyPages] = React.useState(null);
  const [isPolicyOpen, setIsPolicyOpen] = React.useState(false);

  const handleTogglePagesMenu = (event) => {
    setAnchorElPages(event.currentTarget);
    setIsPagesOpen(!isPagesOpen);
  };

  const handleClosePagesMenu = () => {
    setAnchorElPages(null);
    setIsPagesOpen(false);
  };

  // Toggle Policy Pages Menu
  const handleTogglePolicyMenu = (event) => {
    setAnchorElPolicyPages(event.currentTarget);
    setIsPolicyOpen(!isPolicyOpen);
  };

  const handleClosePolicyMenu = () => {
    setAnchorElPolicyPages(null);
    setIsPolicyOpen(false);
  };

  // const policyPage = "/policy"; // Define the path to your policy page

  // ali code
  // const scrollToSection = (id) => {
  //   if (id === "Payment_Policy") {
  //     navigate("/payment-policy"); // Navigate to the Payment Policy page
  //   } else {
  //     const section = document.getElementById(id);
  //     if (section) {
  //       section.scrollIntoView({ behavior: "smooth", block: "start" });
  //       setSelectedPage(id);
  //     }
  //   }
  //   setAnchorElNav(null);
  //   handleClosePagesMenu();
  // };
  // sabir code
  // const scrollToSection = (id) => {
  //   if (id === "Payment_Policy") {
  //     setSelectedPage("Payment_Policy"); // Set the selected page

  //     navigate("/payment-policy"); // Navigate to the Payment Policy page
  //   } else if (id === "Terms_of_service") {
  //     setSelectedPage("Terms_of_service"); // Set the selected page

  //     navigate("/Terms-of-service"); // Navigate to the Payment Policy page
  //   } else if (id === "cancellation_refund_policy") {
  //     setSelectedPage("cancellation_refund_policy"); // Set the selected page

  //     navigate("/cancellation_refund_policy"); // Navigate to the Payment Policy page
  //   } else if (id === "intellectual_property_claim") {
  //     setSelectedPage("intellectual_property_claim"); // Set the selected page

  //     navigate("/intellectual_property_claim"); // Navigate to the Payment Policy page
  //   } else if (id === "Disclaimer") {
  //     setSelectedPage("Disclaimer"); // Set the selected page

  //     navigate("/Disclaimer"); // Navigate to the Payment Policy page
  //   } else if (id === "privacy_policy") {
  //     setSelectedPage("privacy_policy"); // Set the selected page

  //     navigate("/privacy_policy"); // Navigate to the Payment Policy page
  //   }else {
  //     // Check if the current route is not "/"
  //     if (window.location.pathname !== "/") {
  //       // Navigate to the home route first
  //       navigate("/");
  //       // Add a slight delay to ensure the navigation is complete before scrolling
  //       setTimeout(() => {
  //         const section = document.getElementById(id);
  //         if (section) {
  //           section.scrollIntoView({ behavior: "smooth", block: "start" });
  //           setSelectedPage(id);
  //         }
  //       }, 100); // Adjust delay as needed
  //     } else {
  //       const section = document.getElementById(id);
  //       if (section) {
  //         section.scrollIntoView({ behavior: "smooth", block: "start" });
  //         setSelectedPage(id);
  //       }
  //     }
  //   }
  //   setAnchorElNav(null);
  //   handleClosePagesMenu();
  //   handleClosePolicyMenu();
  // };



  const scrollToSection = (id) => {
    // External URLs for Policy Pages
    const policyUrls = {
      "privacy_policy": "https://ambd.info/ambd_policy/privacyPolicy/privacyPolicy.html",
      "Payment_Policy": "https://ambd.info/ambd_policy/paymentPolicy.html",
      "Terms_of_service": "https://ambd.info/ambd_policy/termService/terms-of-service.html",
      "cancellation_refund_policy": "https://ambd.info/ambd_policy/cancellPolicy.html",
      "intellectual_property_claim": "https://ambd.info/ambd_policy/intellectual.html",
      "Disclaimer": "https://ambd.info/ambd_policy/Disclaimer/index.html",
    };
  
    // Check if the ID corresponds to a policy page and open in a new tab
    if (policyUrls[id]) {
      window.open(policyUrls[id], "_blank");
    } else {
      // Default behavior (for other sections)
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: "smooth", block: "start" });
        setSelectedPage(id);
      }
    }
  
    setAnchorElNav(null);
    handleClosePagesMenu();
    handleClosePolicyMenu();
  };
  

  return (
    <AppBar position="fixed" sx={appBarStyles}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {/* Desktop Logo */}
          <Box component="img" sx={logoStyles} alt="Logo" src={logo} />
          <Typography variant="h6" noWrap component="a" href="#" sx={titleStyles}>
            AMBD
          </Typography>

          {/* Mobile Menu */}
          {/* Mobile Menu */}
          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton size="large" aria-label="menu" onClick={handleOpenNavMenu} color="inherit">
              <MenuIcon />
            </IconButton>
            <Box component="img" sx={logoMobileStyles} alt="Logo" src={logo} />

            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: "block", md: "none" } }}
            >
              {pages.map((page) => (
                <Box key={page.name}>
                  {page.name === "Pages" || page.name === "Policy pages" ? (
                    <>
                      {/* Parent Menu Item */}
                      <MenuItem
                        onClick={
                          page.name === "Pages"
                            ? handleTogglePagesMenu
                            : handleTogglePolicyMenu
                        }
                      >
                        <Typography sx={{ textAlign: "center", textTransform: "none" }}>
                          {page.name}
                        </Typography>
                        {page.name === "Pages" && isPagesOpen ? (
                          <ExpandLessIcon />
                        ) : page.name === "Policy pages" && isPolicyOpen ? (
                          <ExpandLessIcon />
                        ) : (
                          <ExpandMoreIcon />
                        )}
                      </MenuItem>

{/* <MenuItem
  key={policyPage.name}
  onClick={() => {
    scrollToSection(policyPage.id);
    handleClosePolicyMenu(); // Close submenu
    handleCloseNavMenu(); // Close main menu
  }}
>
  {policyPage.name}
</MenuItem> */}


                      {/* Submenu for Pages */}
                      {page.name === "Pages" && (
                        <Menu
                          anchorEl={anchorElPages}
                          open={Boolean(anchorElPages)}
                          onClose={handleClosePagesMenu}
                        >
                          {subpages.map((subpage) => (
                            <MenuItem
                              key={subpage.name}
                              onClick={() => {
                                scrollToSection(subpage.id);
                                handleClosePagesMenu(); // Close submenu
                                handleCloseNavMenu(); // Close main menu
                              }}
                            >
                              {subpage.name}
                            </MenuItem>
                          ))}
                        </Menu>
                      )}

                      {/* Submenu for Policy Pages */}
                      {page.name === "Policy pages" && (
                        <Menu
                          anchorEl={anchorElPolicyPages}
                          open={Boolean(anchorElPolicyPages)}
                          onClose={handleClosePolicyMenu}
                        >
                          {policyPages.map((policyPage) => (
                            <MenuItem
                              key={policyPage.name}
                              onClick={() => {
                                scrollToSection(policyPage.id);
                                handleClosePolicyMenu(); // Close submenu
                                handleCloseNavMenu(); // Close main menu
                              }}
                            >
                              {policyPage.name}
                            </MenuItem>
                          ))}
                        </Menu>
                      )}
                    </>
                  ) : (
                    <MenuItem
                      onClick={() => {
                        scrollToSection(page.id);
                        handleCloseNavMenu(); // Close main menu
                      }}
                    >
                      <Typography sx={{ textAlign: "center" }}>{page.name}</Typography>
                    </MenuItem>
                  )}
                </Box>
              ))}
            </Menu>
          </Box>


          {/* Desktop Navigation */}
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {pages.map((page) => (
              <Box key={page.name} sx={{ position: "relative" }}>
                {page.name === "Pages" || page.name === "Policy pages" ? (
                  <>
                    <Button
                      onClick={
                        page.name === "Pages"
                          ? handleTogglePagesMenu // Toggle Pages menu
                          : handleTogglePolicyMenu // Toggle Policy Pages menu
                      }
                      sx={{
                        ...buttonStyles,
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      {page.name}
                      {(page.name === "Pages" && isPagesOpen) ||
                        (page.name === "Policy pages" && isPolicyOpen) ? (
                        <ExpandLessIcon sx={{ fontSize: "20px" }} />
                      ) : (
                        <ExpandMoreIcon sx={{ fontSize: "20px" }} />
                      )}
                    </Button>

                    {/* Pages Menu */}
                    {page.name === "Pages" && (
                      <Menu
                        anchorEl={anchorElPages}
                        open={Boolean(anchorElPages)}
                        onClose={handleClosePagesMenu}
                      >
                        {subpages.map((subpage) => (
                          <MenuItem
                            key={subpage.name}
                            onClick={() => scrollToSection(subpage.id)}
                          >
                            {subpage.name}
                          </MenuItem>
                        ))}
                      </Menu>
                    )}

                    {/* Policy Pages Menu */}
                    {page.name === "Policy pages" && (
                      <Menu
                        anchorEl={anchorElPolicyPages}
                        open={Boolean(anchorElPolicyPages)}
                        onClose={handleClosePolicyMenu}
                      >
                        {policyPages.map((policyPage) => (
                          <MenuItem
                            key={policyPage.name}
                            onClick={() => scrollToSection(policyPage.id)}
                          >
                            {policyPage.name}
                          </MenuItem>
                        ))}
                      </Menu>
                    )}
                  </>
                ) : (
                  <Button
                    onClick={() => scrollToSection(page.id)}
                    sx={buttonStyles}
                  >
                    {page.name}
                  </Button>
                )}
                {selectedPage === page.id && <Box sx={underlineStyles} />}
              </Box>
            ))}
          </Box>

          {/* <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {pages.map((page) => (
              <Box key={page.name} sx={{ position: "relative" }}>
                {page.name === "Pages" ? (
                  <>
                    <Button
                      onClick={handleTogglePagesMenu}
                      sx={{
                        ...buttonStyles,
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      {page.name}
                      {isPagesOpen ? (
                        <ExpandLessIcon sx={{ fontSize: "20px" }} />
                      ) : (
                        <ExpandMoreIcon sx={{ fontSize: "20px" }} />
                      )}
                    </Button>
                    <Menu
                      anchorEl={anchorElPages}
                      open={Boolean(anchorElPages)}
                      onClose={handleClosePagesMenu}
                    >
                      {subpages.map((subpage) => (
                        <MenuItem key={subpage.name} onClick={() => scrollToSection(subpage.id)}>
                          {subpage.name}
                        </MenuItem>
                      ))}
                    </Menu>
                  </>
                ) : (
                  <Button onClick={() => scrollToSection(page.id)} sx={buttonStyles}>
                    {page.name}
                  </Button>
                )}
                {selectedPage === page.id && <Box sx={underlineStyles} />}
              </Box>
            ))}
          </Box> */}

          <Box sx={{ flexGrow: 0 }}>
            <Button
              sx={{
                p: 0,
                background: 'white',
                color: '#0D8B5A',
                borderRadius: '25px', // Rounded corners
                border: '2px solid transparent', // Transparent base border
                backgroundImage: 'linear-gradient(white, white), linear-gradient(180deg, #26FF03 0%, #00FF9B 100%)', // Two layers: one for content, one for border
                backgroundOrigin: 'border-box', // Ensures the background gradient is properly positioned
                backgroundClip: 'padding-box, border-box', // Clips the inner and border backgrounds
                boxShadow: `
                  0px 0px 9.39px 0px #D6FFFF,
                  0px 0px 18.77px 0px #D6FFFF,
                  0px 0px 65.7px 0px #D6FFFF,
                  0px 0px 131.39px 0px #15C07E,
                  0px 0px 225.24px 0px #15C07E,
                  0px 0px 394.18px 0px #15C07E
                `,
              }}
              onClick={() => {
                window.open('https://biz.ambd.info/', '_blank'); // Open link in a new tab
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins, Arial, sans-serif',
                  fontWeight: 500,
                  fontSize: '16px',
                  color: '#0D8B5A',
                  px: 2,
                  py: '2px',
                  textTransform: 'none',
                }}
              >
                Login For Business Owners Only
              </Typography>
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default Navbar;
